import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6befa268"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-15" }, null, -1))
const _hoisted_2 = { class: "search-box" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("生成发票--合并生成")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("生成发票--批量单独")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导入")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("颜色含义")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("表格颜色")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "vat-corlor-row colorMean" }, "可开增值税发票", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "invoice-corlor-row colorMean" }, "可开invoice发票", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invoice-header" }, "生成发票", -1))
const _hoisted_13 = {
  id: "order-invoice",
  style: {"padding":"0 10px"}
}
const _hoisted_14 = { class: "d-flex justify-content--between invoice-header-top" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "invoice-num-text" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Invoice ")
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invoice-label" }, "Client", -1))
const _hoisted_21 = { class: "invoice-info" }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invoice-label" }, "Contact", -1))
const _hoisted_24 = { class: "invoice-info" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invoice-label" }, "Issue Date", -1))
const _hoisted_27 = { class: "invoice-info" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invoice-label" }, "Due Date", -1))
const _hoisted_30 = { class: "invoice-info" }
const _hoisted_31 = { class: "d-flex align-items-center" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invoice-label" }, "Address", -1))
const _hoisted_33 = { class: "invoice-info" }
const _hoisted_34 = { class: "d-flex align-items-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "invoice-label" }, "Issue by", -1))
const _hoisted_36 = { class: "invoice-info" }
const _hoisted_37 = {
  class: "mt-15 d-flex",
  style: {"justify-content":"flex-end"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment-txt" }, "Payments", -1))
const _hoisted_39 = {
  key: 0,
  class: "mb-15 payment-content"
}
const _hoisted_40 = {
  key: 1,
  class: "mb-15 payment-content"
}
const _hoisted_41 = { style: {"margin-right":"2px"} }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "payment-txt" }, "Company Address", -1))
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "payment-txt" }, "Notes：", -1))
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = {
  key: 3,
  class: "invoice-note"
}
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" 开票类型： ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("invoice")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("增值税发票")
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "发票主体", -1))
const _hoisted_54 = { class: "d-flex mb-10" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "公司地址", -1))
const _hoisted_56 = { class: "d-flex mb-10" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "收款银行", -1))
const _hoisted_58 = { class: "bank-list" }
const _hoisted_59 = {
  class: "d-flex",
  style: {"max-width":"300px","flex-wrap":"wrap"}
}
const _hoisted_60 = /*#__PURE__*/_createTextVNode("选择")
const _hoisted_61 = { class: "d-flex mb-10" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "Issue By", -1))
const _hoisted_63 = { class: "d-flex mb-10" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "备注", -1))
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "是否展示销售方电话地址银行账号", -1))
const _hoisted_68 = { style: {"flex":"1"} }
const _hoisted_69 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "受票方自然人标识", -1))
const _hoisted_71 = { style: {"flex":"1"} }
const _hoisted_72 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "购买方名称", -1))
const _hoisted_74 = {
  style: {"flex":"1"},
  type: "textarea",
  autosize: "",
  disabled: ""
}
const _hoisted_75 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "税号", -1))
const _hoisted_77 = {
  style: {"flex":"1"},
  type: "textarea",
  autosize: "",
  disabled: ""
}
const _hoisted_78 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "是否展示购买方电话地址银行账号", -1))
const _hoisted_80 = { style: {"flex":"1"} }
const _hoisted_81 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "购买方地址", -1))
const _hoisted_83 = { style: {"flex":"1"} }
const _hoisted_84 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "电话", -1))
const _hoisted_86 = { style: {"flex":"1"} }
const _hoisted_87 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "购买方开户银行", -1))
const _hoisted_89 = { style: {"flex":"1"} }
const _hoisted_90 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "银行账号", -1))
const _hoisted_92 = { style: {"flex":"1"} }
const _hoisted_93 = { class: "d-flex mb-10" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "发票类型", -1))
const _hoisted_95 = /*#__PURE__*/_createTextVNode("普通发票(电子)")
const _hoisted_96 = /*#__PURE__*/_createTextVNode("增值税专用发票(电子)")
const _hoisted_97 = { class: "d-flex mb-10" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "是否含税", -1))
const _hoisted_99 = { class: "d-flex mb-10" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "备注(备注内容会显示在发票的备注栏)", -1))
const _hoisted_101 = { class: "d-flex mb-10" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "补充说明(给财务的备注说明写在此栏，不会显示在发票备注栏)", -1))
const _hoisted_103 = { class: "d-flex mb-10" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "项目名称", -1))
const _hoisted_105 = { class: "d-flex mb-10" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "规格型号", -1))
const _hoisted_107 = { class: "d-flex mb-10" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "单位", -1))
const _hoisted_109 = { class: "d-flex mb-10" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "数量", -1))
const _hoisted_111 = { class: "d-flex mb-10" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "单价", -1))
const _hoisted_113 = { class: "d-flex mb-10" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "金额", -1))
const _hoisted_115 = { class: "d-flex mb-10" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "销售方名称", -1))
const _hoisted_117 = { class: "d-flex mb-10" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "信用代码", -1))
const _hoisted_119 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "销售方地址", -1))
const _hoisted_121 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "电话", -1))
const _hoisted_123 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "销售方开户银行", -1))
const _hoisted_125 = { class: "d-flex mb-10 align-items-center" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"100px"},
  class: "mr-10"
}, "银行账号", -1))
const _hoisted_127 = { style: {"text-align":"right"} }
const _hoisted_128 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_129 = /*#__PURE__*/_createTextVNode("确认生成")
const _hoisted_130 = /*#__PURE__*/_createTextVNode("打印")
const _hoisted_131 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_132 = { class: "account-info" }
const _hoisted_133 = { class: "account-info" }
const _hoisted_134 = ["innerHTML"]
const _hoisted_135 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_136 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_137 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_138 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_139 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_140 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_141 = { class: "d-flex align-items-center mb-15" }
const _hoisted_142 = /*#__PURE__*/_createTextVNode()
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "check-model" }, "订单金额/币种/发票主体/订单状态与co3不一致", -1))
const _hoisted_144 = { style: {"color":"#E6A23C"} }
const _hoisted_145 = { key: 0 }
const _hoisted_146 = { key: 1 }
const _hoisted_147 = { key: 2 }
const _hoisted_148 = { key: 3 }
const _hoisted_149 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_150 = /*#__PURE__*/_createTextVNode("更新数据")

import { ref,  reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox} from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { statusMap } from '@/views/typeMapping/Financial'
import dayjs from 'dayjs'
import { formatNumber, exportHandle,getNumber } from '@/utils/index'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import { useRoute } from 'vue-router'
import InvoiceTable from "./InvoiceTable.vue"
import InvoiceList from "./InvoiceList.vue"
import TaxInvoice from "./TaxInvoice.vue"
import AdvancePayment from "./advancePayment.vue"
import printJS from 'print-js'
import Api from '@/http/modules/index'
import html2pdf from 'html2pdf.js'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import { validEmail } from '@/utils/validate'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {paymentCompany, currencyOption}=PaymentModuleUtils
let {
    // 待生成发票
    'POST/order/pending':orderPendingListApi,
    // 获取开票信息
    'POST/order/create_info':orderCreateInfoApi,
    // 开票
    'POST/order/create_invoice':creatInvoiceApi,
    // 根据id获取发票
    'GET/order/invoice/{id}':invoiceApi,
    // 正在使用的税收项目列表
	'GET/order/invoice/items':invoiceItemsApi,
    // 正在使用的单位、规格型号列表
    'GET/order/invoice/settings':invoiceSettingApi,
    // 解析订单号
    'POST/order/invoice/analyze_orderNo':analyzeOrderNOApi,
    // 未完工订单开票
    'POST/order/create_invoice/no_order':noOrderCreatInvoiceApi,
    //开票校验
   'POST/order/check_order':checkOrderApi,
    // 更新信息
    'POST/order/update_check_order':update_check_orderApi,
} = Api
const invoiceForm=ref<any>({
    statusList:[]    
})
const pageInfo=reactive({
    page:1,
    size:30,
    total:0
})
const statusList=ref([ 'delivered', 'delivering', 'invoiced', 'proceeding', 'closed', 'closedeve', 'closedhz' ])
const tableHeight=window.innerHeight-300
const invoiceLists=ref([])
const invoiceTableRef=ref()
const invoiceListsLoading=ref(false)
const getInvoiceLists=(isReset:boolean=false)=>{
    if(isReset){
        invoiceForm.value={
            statusList:[]                
        }
        pageInfo.page=1,
        pageInfo.size=30
        invoiceTableRef.value.clearSort()
        sortParams.value={}
    }
    let {page,size}=pageInfo
    let {no,createTime,deliverTime,currency,customerName,poNumber,createType,statusList}=invoiceForm.value
    let params={        
        query:{
            no:no||"",
            poNumber:poNumber||'',
            startTimeFrom:createTime?dayjs(createTime[0]).format('YYYY-MM-DD'):"",
            startTimeTo:createTime?dayjs(createTime[1]).format('YYYY-MM-DD'):"",
            deliverTimeFrom:deliverTime?dayjs(deliverTime[0]).format('YYYY-MM-DD'):"",
            deliverTimeTo:deliverTime?dayjs(deliverTime[1]).format('YYYY-MM-DD'):"",
            customerName:customerName||'',
            currency:currency||'',
            page,size,
            createType,
            statusList:statusList||[]
        },
        sort:sortParams.value
    }
    invoiceListsLoading.value=true
    orderPendingListApi(params).then((res:any)=>{
        invoiceListsLoading.value=false
        invoiceLists.value=res.data
        pageInfo.total=res.rowCount
    }).catch(()=>{
        invoiceListsLoading.value=false
    })
}
const invoiceSelected=ref<any>([])
const showTips=ref(true) //勾选的值存在proceeding/delivering的订单
const handleSelectionChange=(val:any)=>{
    invoiceSelected.value=val
    if(!val.length){ //没有选中任何数据时
        showTips.value=true
        return
    }
    showTips.value=val.every((el:any)=>el.status!='proceeding'&&el.status!='delivering')    
}
const activeInvoice=ref<any>('开票信息')
const invoiceType=ref('1')
const invoiceTypeChange=()=>{
    activeInvoice.value=invoiceType.value=='1'?'开票信息':['关键信息','基本信息']
}

// 检查已勾选的数据中客户和币种是否相同
const checkData=()=>{
    if(invoiceSelected.value.length==1){ //当勾选的数据只有一条时，客户和币种是相同
        return true
    }
    let data=invoiceSelected.value[0]
    return invoiceSelected.value.every((el:any)=>el.customerUsername==data.customerUsername&&el.currency==data.currency)
}

const invoiceInfo=ref<any>({})
const invoiceVisible=ref(false)
const InvoiceListRef=ref()
const vatInvoiceListRef=ref()
const disableTaxInvoice=ref(false) //币种只有是CNY才能生成增值税发票
const isMerge=ref(true) //控制批量合并还是批量单独
const currentCreatType=ref('')
const resetForm=()=>{
    invoiceType.value="1"
    activeInvoice.value="开票信息"
    selectedBankList.value=[]
    selectedBankListHistory.value=[]
    isRecreate.value=false
    recreateReason.value=""
    recreateId.value=""
    isAdvancePayment.value=false,
    currentCreatType.value=""
}
const ordeInvoice=async (type:string)=>{    
    if(!invoiceSelected.value.length){
        ElMessage.warning("请选择要生成发票的数据")
        return
    }
    let orderNos:any=invoiceSelected.value.map((el:any)=>el.no)
    if(type=='merge'){ //批量合并需要币种和客户都相同才可以
        let res=await checkData()
        if(!res){
            ElMessage.warning("请选择客户和币种相同的的订单")
            return
        }
    }
    let res= invoiceSelected.value.every((el:any)=>el.client!=null&&el.client!='')
    if(!res){
        ElMessage.warning("订单中未找到对应的客户数据,请先让财务人员更新客户信息")
        return 
    }
    currentCreatType.value=type       
    getOrderCreateInfo(orderNos,type)
}
const getOrderCreateInfo=(orderNos:any,type:string)=>{
    let params={orderNos,type}
    orderCreateInfoApi(params).then((res:any)=>{
        invoiceInfo.value=res
        let {bankList,selectBank}=res.invoiceInfo  
        let arr:any=[]      
        if(selectBank&&selectBank.length){ //设置默认收款银行         
            (selectBank as Array<any>).forEach((el:any)=>{
              let res= ( bankList as Array<any>).find((item:any)=>item.accountInfo==el)
              if(res){
                  arr.push(res)
              }
            })
            selectedBankList.value=arr
            selectedBankListHistory.value=arr
        }
        // disableTaxInvoice.value=!(invoiceSelected.value.every((el:any)=>el.currency=='CNY')) //增值税发票必须是人民币才能开具
        disableTaxInvoice.value=!res.allowVat||false //增值税发票必须是人民币才能开具
        invoiceType.value=showTips.value?'1':'2'
        activeInvoice.value=invoiceType.value=='1'?'开票信息':['关键信息','基本信息']
        invoiceVisible.value=true
        isShowImport.value=false //关闭导入弹窗
    })
}
// 获规格型号，单位
const unitOption=ref([])
const specOptipon=ref([])
const getInvoiceOption=(type:string)=>{
    let params={type}
    invoiceSettingApi(params).then((res:any)=>{
        if(type=='unit'){
            unitOption.value=res
        }else{
            specOptipon.value=res
        }
    })   
}   
const settingSelect=(event:any,type:string)=>{
     // 事件对象
    // 获取选择器结果(value可能是手动输入的,也可能是下拉选择的)
    let value = event.target.value
    // 检查选择器结果,是否可以匹配到"选项列表"
    // - 如果可以匹配到选项列表,则证明是从下拉选择的
    // - 如果无法匹配到选项列表,则证明是手动输入的
    let dataList:any=type=='unit'?unitOption.value:specOptipon.value
    try {
        dataList.forEach((item:any) => {
            // console.log(item)
            if(item.label == value) {
                // console.log('相同,是下拉框中选择的结果!')
                invoiceInfo.value.vatInfo[type] = item.value//赋值真实值
                // 抛出错误,终止循环
                throw Error();
            }
        })
    } catch (error) {
        return false;//立即终止
    }
    // ----正常赋值----
    if(value) {
        invoiceInfo.value.vatInfo[type] = value
    }
}
const bankListVisiable=ref(false)
const selectedBankList=ref([])
const selectedBankListHistory=ref([])
const bankListRef=ref()
const bankListChange=(val:any)=>{
    selectedBankList.value=val
}
const selectBankHandle=(isSure:boolean)=>{
    if(isSure){
        invoiceInfo.value.invoiceInfo.selectBank=selectedBankList.value.map((el:any)=>el.accountInfo)  
        selectedBankListHistory.value=selectedBankList.value
    }else{
        selectedBankList.value=selectedBankListHistory.value
    }    
    bankListVisiable.value=false
}
const openBankList=()=>{
    bankListRef.value!.clearSelection()
    selectedBankList.value.forEach((row:any)=>{
        bankListRef.value!.toggleRowSelection(row) 
    })
}
const checkOrderVisiable=ref(false)
const checkRes=ref<any>([])
const updataOrderLoading=ref(false)
const closeChecOrderVisiable=()=>{
    // invoiceVisible.value=false
    checkRes.value=[]
}
const updataOrder=()=>{
    let orderNos:any=invoiceSelected.value.map((el:any)=>el.no)
    updataOrderLoading.value=true
    update_check_orderApi({orderNos}).then(()=>{
        ElMessage.success('更新成功')
        checkOrderVisiable.value=false
        getOrderCreateInfo(orderNos,currentCreatType.value)
    }).finally(()=>{
        updataOrderLoading.value=false
    })
}
const creatInvoice=async ()=>{
    let {itemName,specification,unit,quantity,unitPrice,showAddressAndPhone,showBankInfo,buyerAddress,buyerPhone,buyerBank,buyerBankAccount,
        sellerAddress,sellerPhone,showSellerAddressAndPhone,sellerBank,sellerBankAccount,showSellerBankInfo,taxNo,naturalPersonIdentification}=invoiceInfo.value.vatInfo  
    // 订单中是否含有未delivered的订单
    let isDelivered= invoiceSelected.value.every((el:any)=>el.status=='delivered')
    let hasProceeding= invoiceSelected.value.every((el:any)=>el.status!='proceeding')

    // invoice申请时需要所有订单都为delivered才可以开票，增值税发票申请时有订单的status为proceeding时弹窗，但是可以继续申请开票
    if((invoiceType.value=='1'&&!isDelivered)||(invoiceType.value=='2'&&hasProceeding)){
        let handleRes=await  ElMessageBox.confirm(`开票申请含有非delivered的订单，${invoiceType.value=='1'?'不允许开票':'请先确认订单金额是否和CO2一致!!!'}`,{confirmButtonText:"确定",cancelButtonText:'取消'})
        if(!handleRes||(handleRes&&invoiceType.value=='1')){ //点击取消，或者点确定的时候，invoice申请选项终止开票请求
            return
        }        
    }   
    if(invoiceType.value=='2'){
        if(!taxNo&&!naturalPersonIdentification){
            ElMessage.warning('请输入税号')
            return
        }
        if(!itemName||(isNeed.value&&!specification)||(isNeed.value&&!unit)||!quantity||!unitPrice){
            ElMessage.warning('请把基本信息补充完整')
            return
        }
        if((showSellerAddressAndPhone&&(!sellerAddress||!sellerPhone))||(showSellerBankInfo&&(!sellerBank||!sellerBankAccount))){ //判断是否勾选展示销售方银行电话地址
            ElMessage.warning('请完善是否展示销售方电话地址银行账号')
            return
        }
        if((showAddressAndPhone&&(!buyerAddress||!buyerPhone))||(showBankInfo&&(!buyerBank||!buyerBankAccount))){ //判断是否勾选展示购买方银行电话地址
            ElMessage.warning('请完善是否展示购买方电话地址银行账号')
            return
        }
    }
    let params:any=JSON.parse(JSON.stringify(invoiceInfo.value))

    params.createType=invoiceType.value=='2'?'VAT':'INVOICE'    
    if(isRecreate.value){ //销售重新开票
        params.id=recreateId.value
        params.reason=recreateReason.value
    }
    const checkParams={
       orderNos:params.orderNos,
       createType:params.createType
    }
    checkRes.value=await checkOrderApi(checkParams)    
    if(checkRes.value.length) {//校验返回的是数组，有数组代表订单与co2订单存在差异
        checkOrderVisiable.value=true
        return
    } 
    let handleApi=isAdvancePayment.value?noOrderCreatInvoiceApi:creatInvoiceApi
    handleApi(params).then(()=>{
        ElMessage.success("发票创建成功")
        invoiceVisible.value=false
        if(!isAdvancePayment.value){
            getInvoiceLists()
            if(invoiceType.value=='1'){
                InvoiceListRef.value.getInvoiceLists()
                return
            }
        }else{
            advancePaymentRef.value.getOrderLists()
        }
        vatInvoiceListRef.value.getInvoiceLists()
        ElMessageBox.confirm("开票申请已提交，开票时间：周二下午5点前提交的申请，周二当天开具，周二下午5点之后至周五下午5点前提交的申请，周五当天开具！",{confirmButtonText:'确定',showCancelButton:false})
    })
}
const handelOption=ref('print')
const getInvoiceInfo=({data,option}:any)=>{
    handelOption.value=option
    invoiceApi({id:data.id}).then((res:any)=>{
        invoiceInfo.value=res
        invoiceVisible.value=true
    })
}
const printInvoice=(option:string)=>{    
    const invoiceEl:any=document.querySelector('#order-invoice')
    html2Canvas(invoiceEl,{
        // allowTaint: true 和 useCORS: true 都是解决跨域问题的方式，不同的是使用allowTaint 会对canvas造成污染，导致无法使用canvas.toDataURL 方法，所以这里不能使用allowTaint: true
        allowTaint: false,
        useCORS:true, ////允许加载跨域的图片
        //防止页面过宽导致右侧出现黑灰色背景区域
        scale: 2,
        height: invoiceEl.outerHeight,
        width: invoiceEl.outerWidth,
        windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight
      })
      .then(function (canvas) {
        const url = canvas.toDataURL()
        if(option=='print'){
            printJS({
                printable: url,
                type: 'image',
                style:`@media print { @page {size: auto; margin: 30px; } body{margin:0 5px}}` // 解决出现多页打印时第一页空白问题
            })
            return
        }
        const a4Width = 595.28
          const a4Height = 841.89
          // 可以上传后端或者直接显示
          // 用于将canvas对象转换为base64位编码
          var context:any = canvas.getContext('2d')
          context.mozImageSmoothingEnabled = false
          context.webkitImageSmoothingEnabled = false
          context.msImageSmoothingEnabled = false
          context.imageSmoothingEnabled = false
          let position = 0

          // 生成的画布元素宽高
          const canvasWidth = canvas.width
          const canvasHeight = canvas.height

          // 页面等比例缩放后宽高
          const pageWidth = a4Width
          const pageHeight = (a4Width / canvasWidth) * canvasHeight

          // 返回图片dataURL，参数：图片格式和清晰度(0-1)
          const jpeg = canvas.toDataURL('image/jpeg', 1.0)
          // 第一个参数是纵横向，第二个参数是单位，第三个参数是生成pdf的大小，自定义pdf大小的话可以传入一个数组，eg：[164.14, 424.5]
          // 方向默认竖直，尺寸ponits，格式a4 [595.28,841.89]
          // const pdf = new JsPDF('', 'pt', [595.28, 841.89]/* [a4Width, a4Height] */)
          const pdf = new JsPDF('', 'pt', [605.28, 841.89]/* [a4Width, a4Height] */)
          // const pdf = new JsPDF('', 'pt', [this.contentWidth, 841.89]/* [a4Width, a4Height] */)
          // const pdf = new JsPDF('', 'pt', 'a4'/* [a4Width, a4Height] */)

          // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
          // 当内容未超过pdf一页显示的范围，无需分页
          let height = pageHeight
          if (height < a4Height) {
          // 第三，四个参数是图片偏移位置，第五六个参数是生成的图片的宽高
            pdf.addImage(jpeg, 'JPEG', 5, 5, pageWidth, pageHeight) // 从图片顶部开始打印
          } else {
            while (height > 0) {
              pdf.addImage(jpeg, 'JPEG', 0, position, pageWidth, pageHeight)
              height -= a4Height
              position -= a4Height
              // 避免添加空白页
              if (height > 0) {
                pdf.addPage()
              }
            }
          }
          pdf.save(`发票.pdf`)
        
      })
}
const sortParams=ref<any>({})
const sortMethods=({prop,order}:any)=>{
    let orderVal=order?order=='descending'?'DESC':'ASC':''
    if(orderVal){
        if(prop=='startTime'){
            sortParams.value.start_time=orderVal
        }
        if(prop=='deliverTime'){
            sortParams.value.deliver_time=orderVal
        }  
    }else{
         if(prop=='startTime'){
           delete sortParams.value.start_time
        }
        if(prop=='deliverTime'){
            delete sortParams.value.deliver_time
        }
    }
    getInvoiceLists()
}
const formatDecimal=(num:any)=> {
  // 将数字转换为字符串
  const numStr = num.toString();
  // 使用正则表达式匹配小数点后超过4位的数字，并将其替换为小数点后4位的数字
  const formattedStr = numStr.replace(/(\.\d{5,})|(\.0*)/, function(match:any, p1:any, p2:any) {
    if (match) {
      return '.'.concat(match.substring(1, 5)); // 保留小数点后4位
    } else {
      return ''; // 如果是小数点开头或者全是0，则返回空字符串
    }
  });
  // 将格式化后的字符串再次转换为数字
  return parseFloat(formattedStr);
}
const unitPriceOrquantityChange=(ops:string)=>{
    // invoiceInfo.value.vatInfo.totalAmount
    let {vatInfo}=invoiceInfo.value
    let targetOps:any=vatInfo.totalAmount/vatInfo[ops]
    if(ops=='quantity'){
        vatInfo.unitPrice=formatDecimal(targetOps)
        return
    }
    vatInfo.quantity=formatDecimal(targetOps)
}
const itemList=ref([])
const isNeed=ref(true) //用于控制增值税发票，规格型号，单位信息是否必填
const itemChange=(value:any)=>{
    let res:any=itemList.value.find((el:any)=>el.name==value)
    invoiceInfo.value.vatInfo.itemNo=res.taxNo||''
    isNeed.value=res.need
}
const  replaceAll=(str:string)=> {
  return str.replace(new RegExp('\r\n', 'g'), '<br />');
}
const remarkHTML=(remark:any)=> {
  if (remark) {
    return remark.replace(/\n|\r\n/g, '<br>').replace(/ /g, '  ')
  }
  return ''
}

// 销售重开发票申请
const isRecreate=ref(false)
const recreateReason=ref('')
const recreateReaonVisiable=ref(false)
const recreateId=ref("")
const resetInvoiceData=ref<any>({})
const recreateHandle=(data:any)=>{
    resetInvoiceData.value=data
    recreateReaonVisiable.value=true
}
const recreateMethods=(data:any)=>{
    if(!recreateReason.value){
        ElMessage.warning('请填写发票重开原因')
        return 
    }
    let params={
        orderNos:data.orderNos,
        type:'merge'
    }
    orderCreateInfoApi(params).then((res:any)=>{
        invoiceInfo.value=res
        let {bankList,selectBank}=res.invoiceInfo  
        let arr:any=[]      
        if(selectBank&&selectBank.length){ //设置默认收款银行         
            (selectBank as Array<any>).forEach((el:any)=>{
              let res= ( bankList as Array<any>).find((item:any)=>item.accountInfo==el)
              if(res){
                  arr.push(res)
              }
            })
            selectedBankList.value=arr
            selectedBankListHistory.value=arr
        }
        // disableTaxInvoice.value=!(invoiceSelected.value.every((el:any)=>el.currency=='CNY')) //增值税发票必须是人民币才能开具
        disableTaxInvoice.value=!res.allowVat||false //根据后台返回的信息决定能否开具增值税发票
        invoiceType.value=showTips.value?'1':'2'
        activeInvoice.value=invoiceType.value=='1'?'开票信息':['关键信息','基本信息']
        invoiceVisible.value=true
        isRecreate.value=true
        recreateId.value=data.id
        recreateReaonVisiable.value=false
    })
}

// 对已开具增值税发票/invoice发票高亮显示
const tableRowClassName = ({ row, rowIndex }: any) => {
  if (row.hasInvoice) {
    return 'vat-corlor-row'
  }
  if(row.hasVatInvoice){
    return 'invoice-corlor-row'
  }
  return ''
}

// 导入（解析订单号）
const isShowImport=ref(false)
const nos=ref('')
const submitImportLoading=ref(false)
const submitImport=async ()=>{
    if(!nos.value){
        ElMessage.warning("请输入订单号")
        return
    }
    let params={nos:nos.value}
    submitImportLoading.value=true
    analyzeOrderNOApi(params,{contentType: 'formData'}).then((res:any)=>{
        if(res.invalidNos.length){ //有值表述输入的订单号有问题
            ElMessageBox({
                title:"请确认存在问题的订单号",
                message:res.invalidNos.join(","),
                type:'warning',
                showCancelButton:false
            })
            return
        }
        getOrderCreateInfo(res.orderNos,'merge')
    }).finally(()=>{
        submitImportLoading.value=false
    })
}

// 未完工订单开票
const isAdvancePayment=ref(false)
const advancePaymentRef=ref()
const advancePaymentCreatInvoice=({orderNos,type}:any)=>{
    orderCreateInfoApi({orderNos,type}).then((res:any)=>{
        invoiceInfo.value=res
        disableTaxInvoice.value=!res.allowVat||false //根据后台返回的信息决定能否开具增值税发票
        invoiceType.value='2'
        activeInvoice.value=['关键信息','基本信息']
        invoiceVisible.value=true
        isAdvancePayment.value=true
    })
}
onMounted(()=>{
    getInvoiceLists()
    getInvoiceOption('unit')
    getInvoiceOption('spec')
	invoiceItemsApi().then((res:any)=>{
        // itemLists.value=res
        itemList.value=res
	})
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_CircleClose = _resolveComponent("CircleClose")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_showTooltip = _resolveDirective("showTooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "新建发票" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, { accordion: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, { title: "点击搜索" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_form, {
                        inline: "",
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "订单号：" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                style: {"width":"220px"},
                                modelValue: invoiceForm.value.no,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((invoiceForm.value.no) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "客户名称: " }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                style: {"width":"220px"},
                                modelValue: invoiceForm.value.customerName,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((invoiceForm.value.customerName) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "货币：" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                style: {"width":"220px"},
                                modelValue: invoiceForm.value.currency,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((invoiceForm.value.currency) = $event)),
                                placeholder: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currencyOption)(), (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.label,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "状态：" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                style: {"width":"220px"},
                                clearable: "",
                                multiple: "",
                                "collapse-tags-tooltip": "",
                                "collapse-tags": "",
                                modelValue: invoiceForm.value.statusList,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((invoiceForm.value.statusList) = $event)),
                                placeholder: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusList.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "PO号: " }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                style: {"width":"220px"},
                                modelValue: invoiceForm.value.poNumber,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((invoiceForm.value.poNumber) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "可开发票: " }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                style: {"width":"220px"},
                                onChange: _cache[5] || (_cache[5] = ()=>getInvoiceLists()),
                                clearable: "",
                                modelValue: invoiceForm.value.createType,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((invoiceForm.value.createType) = $event)),
                                placeholder: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "增值税发票",
                                    value: "VAT"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Invoice发票",
                                    value: "INVOICE"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "创建日期：" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: invoiceForm.value.createTime,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((invoiceForm.value.createTime) = $event)),
                                type: "daterange",
                                "range-separator": "至",
                                "start-placeholder": "开始时间",
                                "end-placeholder": "结束时间",
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "交付日期：" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: invoiceForm.value.deliverTime,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((invoiceForm.value.deliverTime) = $event)),
                                type: "daterange",
                                "range-separator": "至",
                                "start-placeholder": "开始时间",
                                "end-placeholder": "结束时间",
                                clearable: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (getInvoiceLists()))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (getInvoiceLists(true)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_4
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_space, { class: "mb-10 mt-10" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (ordeInvoice('merge')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: "存在proceeding/delivering的订单无法批量生成",
                  placement: "top-start",
                  disabled: showTips.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      disabled: invoiceSelected.value.length&&!showTips.value?true:false,
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (ordeInvoice('batch')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (isShowImport.value=true))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_popover, {
                  placement: "bottom",
                  width: 400,
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "info" }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_divider, null, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    _hoisted_10,
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              "row-class-name": tableRowClassName,
              "max-height": tableHeight,
              ref_key: "invoiceTableRef",
              ref: invoiceTableRef,
              onSortChange: sortMethods,
              onSelectionChange: handleSelectionChange,
              border: "",
              data: invoiceLists.value,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "55"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "no",
                  label: "订单号",
                  width: "120"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "client",
                  label: "客户名称"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "contact",
                  label: "联系人"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "订单名称",
                  width: "180",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "owner",
                  label: "客户经理"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "creator",
                  label: "创建人"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "poNumber",
                  label: "PO号"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "po",
                  label: "PO"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "amount",
                  label: "总金额",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "currency",
                  label: "货币"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "startTime",
                  label: "开始时间",
                  sortable: "",
                  formatter: (row)=>_unref(dayjs)(row.startTime).format('YYYY-MM-DD')
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "deliverTime",
                  label: "交付时间",
                  sortable: "",
                  formatter: (row)=>_unref(dayjs)(row.deliverTime).format('YYYY-MM-DD')
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  prop: "invoiceCompany",
                  label: "开票主体"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "status",
                  label: "状态"
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, invoiceListsLoading.value]
            ]),
            _createVNode(_component_el_pagination, {
              class: "mt-15",
              "current-page": _unref(pageInfo).page,
              "onUpdate:current-page": _cache[14] || (_cache[14] = ($event: any) => ((_unref(pageInfo).page) = $event)),
              "page-size": _unref(pageInfo).size,
              "onUpdate:page-size": _cache[15] || (_cache[15] = ($event: any) => ((_unref(pageInfo).size) = $event)),
              onSizeChange: _cache[16] || (_cache[16] = ()=>getInvoiceLists()),
              onCurrentChange: _cache[17] || (_cache[17] = ()=>getInvoiceLists()),
              background: "",
              layout: "prev, pager, next, sizes, total",
              total: _unref(pageInfo).total,
              "page-sizes": [30, 60, 100, 120]
            }, null, 8, ["current-page", "page-size", "total"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { label: "发票列表" }, {
          default: _withCtx(() => [
            _createVNode(InvoiceList, {
              ref_key: "InvoiceListRef",
              ref: InvoiceListRef,
              onPrint: getInvoiceInfo
            }, null, 512)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { label: "增值税发票列表" }, {
          default: _withCtx(() => [
            _createVNode(InvoiceList, {
              onRecreate: recreateHandle,
              isInvoice: false,
              ref_key: "vatInvoiceListRef",
              ref: vatInvoiceListRef
            }, null, 512)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { label: "预付开票申请" }, {
          default: _withCtx(() => [
            _createVNode(AdvancePayment, {
              ref_key: "advancePaymentRef",
              ref: advancePaymentRef,
              onAdvancePaymentCreatInvoice: advancePaymentCreatInvoice
            }, null, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: invoiceVisible.value,
      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((invoiceVisible).value = $event)),
      width: invoiceInfo.value.invoiceNo?1000:'90%',
      center: "",
      class: "invoice-dialog",
      "show-close": false,
      top: "10px",
      onClose: resetForm
    }, {
      header: _withCtx(() => [
        _hoisted_12,
        _createVNode(_component_el_icon, {
          class: "close-btn",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (invoiceVisible.value=false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CircleClose)
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_127, [
          _createVNode(_component_el_button, {
            onClick: _cache[58] || (_cache[58] = ($event: any) => (invoiceVisible.value=false))
          }, {
            default: _withCtx(() => [
              _hoisted_128
            ]),
            _: 1
          }),
          (invoiceInfo.value.invoiceNo?false:true)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: creatInvoice
              }, {
                default: _withCtx(() => [
                  _hoisted_129
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (invoiceInfo.value.invoiceNo&&handelOption.value=='print')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                onClick: _cache[59] || (_cache[59] = ($event: any) => (printInvoice('print')))
              }, {
                default: _withCtx(() => [
                  _hoisted_130
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (invoiceInfo.value.invoiceNo&&handelOption.value=='download')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                type: "primary",
                onClick: _cache[60] || (_cache[60] = ($event: any) => (printInvoice('download')))
              }, {
                default: _withCtx(() => [
                  _hoisted_131
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: invoiceInfo.value.invoiceNo?24:16
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, { id: "print-content" }, {
                  default: _withCtx(() => [
                    (invoiceType.value=='1')
                      ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                          key: 0,
                          height: "600px",
                          class: "scrollbar-bg"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("img", {
                                  style: {"max-width":"300px"},
                                  crossorigin: "“anonymous”",
                                  src: invoiceInfo.value.invoiceInfo.logo,
                                  alt: "logo"
                                }, null, 8, _hoisted_15),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("div", null, _toDisplayString(invoiceInfo.value.invoiceInfo.invoiceCompany), 1),
                                  (invoiceInfo.value.invoiceNo)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _hoisted_18,
                                        _createElementVNode("span", null, _toDisplayString(invoiceInfo.value.invoiceNo), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createVNode(_component_el_row, { class: "invoice-content" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_19, [
                                        _hoisted_20,
                                        _createElementVNode("div", _hoisted_21, _toDisplayString(invoiceInfo.value.invoiceInfo.client), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_22, [
                                        _hoisted_23,
                                        _createElementVNode("div", _hoisted_24, _toDisplayString(invoiceInfo.value.invoiceInfo.contact), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_25, [
                                        _hoisted_26,
                                        _createElementVNode("div", _hoisted_27, _toDisplayString(invoiceInfo.value.invoiceInfo.issueDate), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_28, [
                                        _hoisted_29,
                                        _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(dayjs)(invoiceInfo.value.invoiceInfo.dueDate).format('YYYY-MM-DD')), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_31, [
                                        _hoisted_32,
                                        _createElementVNode("div", _hoisted_33, _toDisplayString(invoiceInfo.value.invoiceInfo.address), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_34, [
                                        _hoisted_35,
                                        _createElementVNode("div", _hoisted_36, _toDisplayString(invoiceInfo.value.invoiceInfo.issueBy), 1)
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(InvoiceTable, {
                                tableData: invoiceInfo.value.languageService.data,
                                title: "Language Service"
                              }, null, 8, ["tableData"]),
                              _createVNode(InvoiceTable, {
                                lanNum: false,
                                tableData: invoiceInfo.value.designService.data,
                                title: "Design & Muitimedia"
                              }, null, 8, ["tableData"]),
                              _createVNode(InvoiceTable, {
                                lanNum: false,
                                tableData: invoiceInfo.value.itService.data,
                                title: "IT & Software"
                              }, null, 8, ["tableData"]),
                              _createElementVNode("div", _hoisted_37, [
                                _createVNode(_component_el_descriptions, {
                                  column: 1,
                                  border: "",
                                  style: {"width":"350px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_descriptions_item, {
                                      "class-name": "text-align-right",
                                      "label-class-name": "my-label",
                                      label: "Currency"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(invoiceInfo.value.invoiceInfo.currency), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_descriptions_item, {
                                      "class-name": "text-align-right",
                                      "label-class-name": "my-label",
                                      label: "Price Excluding Tax"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(getNumber)(invoiceInfo.value.invoiceInfo.afterTaxAmount)), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_descriptions_item, {
                                      "class-name": "text-align-right",
                                      "label-class-name": "my-label",
                                      label: "VAT Fee"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(getNumber)(invoiceInfo.value.invoiceInfo.taxAmount)), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_descriptions_item, {
                                      "class-name": "text-align-right",
                                      "label-class-name": "my-label",
                                      label: "Tax included Amount"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(getNumber)(invoiceInfo.value.invoiceInfo.amount)), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _hoisted_38,
                              (!invoiceInfo.value.invoiceInfo.selectBank||!invoiceInfo.value.invoiceInfo.selectBank.length)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_39))
                                : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoiceInfo.value.invoiceInfo.selectBank, (item, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        style: {"line-height":"25px"},
                                        class: "mb-10 d-flex",
                                        key: item
                                      }, [
                                        _createElementVNode("div", _hoisted_41, _toDisplayString(index+1) + ".", 1),
                                        _createElementVNode("span", {
                                          innerHTML: replaceAll(item)
                                        }, null, 8, _hoisted_42)
                                      ]))
                                    }), 128))
                                  ])),
                              _hoisted_43,
                              _createElementVNode("p", {
                                class: "payment-content mb-15",
                                innerHTML: remarkHTML(invoiceInfo.value.invoiceInfo.companyAddress)
                              }, null, 8, _hoisted_44),
                              _hoisted_45,
                              (invoiceInfo.value.notes)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 2,
                                    class: "invoice-note payment-content",
                                    innerHTML: remarkHTML(invoiceInfo.value.notes)
                                  }, null, 8, _hoisted_46))
                                : (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(invoiceInfo.value.notes), 1))
                            ])
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(TaxInvoice, {
                          key: 1,
                          itemList: itemList.value,
                          vatInvoiceForm: invoiceInfo.value.vatInfo,
                          notes: invoiceInfo.value.notes,
                          customInfo: invoiceInfo.value.invoiceInfo
                        }, null, 8, ["itemList", "vatInvoiceForm", "notes", "customInfo"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["span"]),
            (invoiceInfo.value.invoiceNo?false:true)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  span: 8
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, null, {
                      default: _withCtx(() => [
                        _hoisted_48,
                        _createVNode(_component_el_radio_group, {
                          modelValue: invoiceType.value,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((invoiceType).value = $event)),
                          onChange: invoiceTypeChange,
                          class: "ml-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_tooltip, {
                              class: "box-item",
                              effect: "dark",
                              content: "存在proceeding/delivering的订单无法批量生成",
                              placement: "top-start",
                              disabled: showTips.value
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, {
                                  label: "1",
                                  disabled: !showTips.value||invoiceForm.value.createType=='VAT'||isAdvancePayment.value
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_49
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            _createVNode(_component_el_radio, {
                              label: "2",
                              disabled: disableTaxInvoice.value||invoiceInfo.value.type=='batch'
                            }, {
                              default: _withCtx(() => [
                                _hoisted_50
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (invoiceType.value=='1')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _createVNode(_component_el_collapse, {
                                modelValue: activeInvoice.value,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((activeInvoice).value = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_collapse_item, {
                                    title: "开票信息",
                                    name: "开票信息"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_52, [
                                        _hoisted_53,
                                        _createVNode(_component_el_input, {
                                          modelValue: invoiceInfo.value.invoiceInfo.invoiceCompany,
                                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((invoiceInfo.value.invoiceInfo.invoiceCompany) = $event)),
                                          style: {"flex":"1"},
                                          type: "textarea",
                                          autosize: "",
                                          disabled: ""
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_54, [
                                        _hoisted_55,
                                        _createVNode(_component_el_input, {
                                          style: {"flex":"1"},
                                          modelValue: invoiceInfo.value.invoiceInfo.companyAddress,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((invoiceInfo.value.invoiceInfo.companyAddress) = $event)),
                                          type: "textarea",
                                          autosize: "",
                                          disabled: ""
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_56, [
                                        _hoisted_57,
                                        _createElementVNode("div", _hoisted_58, [
                                          (selectedBankList.value.length>0)
                                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                                key: 0,
                                                type: "info",
                                                class: "mr-5"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(selectedBankList.value[0].bankName), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          (selectedBankList.value.length>1)
                                            ? (_openBlock(), _createBlock(_component_el_popover, {
                                                key: 1,
                                                width: 300,
                                                trigger: "hover",
                                                placement: "bottom"
                                              }, {
                                                reference: _withCtx(() => [
                                                  _createVNode(_component_el_tag, { type: "info" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("+" + _toDisplayString(selectedBankList.value.length-1), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_59, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedBankList.value, (item, index) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                                        key: item.id
                                                      }, [
                                                        (index>0)
                                                          ? (_openBlock(), _createBlock(_component_el_tag, {
                                                              key: 0,
                                                              type: "info",
                                                              class: "mb-10 mr-10"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(item.bankName), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128))
                                                  ])
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          onClick: _cache[22] || (_cache[22] = ($event: any) => (bankListVisiable.value=true))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_60
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_61, [
                                        _hoisted_62,
                                        _createVNode(_component_el_input, {
                                          style: {"flex":"1"},
                                          modelValue: invoiceInfo.value.invoiceInfo.issueBy,
                                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((invoiceInfo.value.invoiceInfo.issueBy) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_63, [
                                        _hoisted_64,
                                        _createVNode(_component_el_input, {
                                          modelValue: invoiceInfo.value.notes,
                                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((invoiceInfo.value.notes) = $event)),
                                          style: {"flex":"1"},
                                          autosize: { minRows: 4},
                                          type: "textarea"
                                        }, null, 8, ["modelValue"])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              _createVNode(_component_el_collapse, {
                                modelValue: activeInvoice.value,
                                "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((activeInvoice).value = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_scrollbar, { "max-height": "650px" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_collapse_item, {
                                        title: "关键信息",
                                        name: "关键信息"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_66, [
                                            _hoisted_67,
                                            _createElementVNode("div", _hoisted_68, [
                                              _createVNode(_component_el_checkbox, {
                                                modelValue: invoiceInfo.value.vatInfo.showSellerAddressAndPhone,
                                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((invoiceInfo.value.vatInfo.showSellerAddressAndPhone) = $event)),
                                                label: "展示地址、电话",
                                                size: "large"
                                              }, null, 8, ["modelValue"]),
                                              _createVNode(_component_el_checkbox, {
                                                modelValue: invoiceInfo.value.vatInfo.showSellerBankInfo,
                                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((invoiceInfo.value.vatInfo.showSellerBankInfo) = $event)),
                                                label: "展示开户银行、银行账号",
                                                size: "large"
                                              }, null, 8, ["modelValue"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_69, [
                                            _hoisted_70,
                                            _createElementVNode("div", _hoisted_71, [
                                              _createVNode(_component_el_select, {
                                                style: {"width":"100%"},
                                                modelValue: invoiceInfo.value.vatInfo.naturalPersonIdentification,
                                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((invoiceInfo.value.vatInfo.naturalPersonIdentification) = $event))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_option, {
                                                    value: true,
                                                    label: "是"
                                                  }),
                                                  _createVNode(_component_el_option, {
                                                    value: false,
                                                    label: "否"
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_72, [
                                            _hoisted_73,
                                            _createElementVNode("div", _hoisted_74, [
                                              _createVNode(_component_el_input, {
                                                style: {"flex":"1"},
                                                modelValue: invoiceInfo.value.vatInfo.buyerName,
                                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((invoiceInfo.value.vatInfo.buyerName) = $event))
                                              }, null, 8, ["modelValue"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_75, [
                                            _hoisted_76,
                                            _createElementVNode("div", _hoisted_77, [
                                              _createVNode(_component_el_input, {
                                                style: {"flex":"1"},
                                                modelValue: invoiceInfo.value.vatInfo.taxNo,
                                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((invoiceInfo.value.vatInfo.taxNo) = $event))
                                              }, null, 8, ["modelValue"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_78, [
                                            _hoisted_79,
                                            _createElementVNode("div", _hoisted_80, [
                                              _createVNode(_component_el_checkbox, {
                                                modelValue: invoiceInfo.value.vatInfo.showAddressAndPhone,
                                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((invoiceInfo.value.vatInfo.showAddressAndPhone) = $event)),
                                                label: "展示地址、电话",
                                                size: "large"
                                              }, null, 8, ["modelValue"]),
                                              _createVNode(_component_el_checkbox, {
                                                modelValue: invoiceInfo.value.vatInfo.showBankInfo,
                                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((invoiceInfo.value.vatInfo.showBankInfo) = $event)),
                                                label: "展示开户银行、银行账号",
                                                size: "large"
                                              }, null, 8, ["modelValue"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_81, [
                                            _hoisted_82,
                                            _createElementVNode("div", _hoisted_83, [
                                              _createVNode(_component_el_input, {
                                                disabled: !invoiceInfo.value.vatInfo.showAddressAndPhone,
                                                style: {"flex":"1"},
                                                modelValue: invoiceInfo.value.vatInfo.buyerAddress,
                                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((invoiceInfo.value.vatInfo.buyerAddress) = $event))
                                              }, null, 8, ["disabled", "modelValue"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_84, [
                                            _hoisted_85,
                                            _createElementVNode("div", _hoisted_86, [
                                              _createVNode(_component_el_input, {
                                                disabled: !invoiceInfo.value.vatInfo.showAddressAndPhone,
                                                style: {"flex":"1"},
                                                modelValue: invoiceInfo.value.vatInfo.buyerPhone,
                                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((invoiceInfo.value.vatInfo.buyerPhone) = $event))
                                              }, null, 8, ["disabled", "modelValue"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_87, [
                                            _hoisted_88,
                                            _createElementVNode("div", _hoisted_89, [
                                              _createVNode(_component_el_input, {
                                                disabled: !invoiceInfo.value.vatInfo.showBankInfo,
                                                style: {"flex":"1"},
                                                modelValue: invoiceInfo.value.vatInfo.buyerBank,
                                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((invoiceInfo.value.vatInfo.buyerBank) = $event))
                                              }, null, 8, ["disabled", "modelValue"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_90, [
                                            _hoisted_91,
                                            _createElementVNode("div", _hoisted_92, [
                                              _createVNode(_component_el_input, {
                                                disabled: !invoiceInfo.value.vatInfo.showBankInfo,
                                                style: {"flex":"1"},
                                                modelValue: invoiceInfo.value.vatInfo.buyerBankAccount,
                                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((invoiceInfo.value.vatInfo.buyerBankAccount) = $event))
                                              }, null, 8, ["disabled", "modelValue"])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_93, [
                                            _hoisted_94,
                                            _createVNode(_component_el_radio_group, {
                                              modelValue: invoiceInfo.value.vatInfo.invoiceType,
                                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((invoiceInfo.value.vatInfo.invoiceType) = $event)),
                                              class: "ml-4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_radio, { label: "ORDINARY" }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_95
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_el_radio, { label: "SPECIAL" }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_96
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_97, [
                                            _hoisted_98,
                                            _createVNode(_component_el_switch, {
                                              "active-text": "是",
                                              "inline-prompt": "",
                                              "inactive-text": "否",
                                              modelValue: invoiceInfo.value.vatInfo.includingTax,
                                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((invoiceInfo.value.vatInfo.includingTax) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_99, [
                                            _hoisted_100,
                                            _createVNode(_component_el_input, {
                                              style: {"flex":"1"},
                                              modelValue: invoiceInfo.value.notes,
                                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((invoiceInfo.value.notes) = $event)),
                                              autosize: { minRows: 4},
                                              type: "textarea"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_101, [
                                            _hoisted_102,
                                            _createVNode(_component_el_input, {
                                              style: {"flex":"1"},
                                              modelValue: invoiceInfo.value.financialNotes,
                                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((invoiceInfo.value.financialNotes) = $event)),
                                              autosize: { minRows: 2},
                                              type: "textarea"
                                            }, null, 8, ["modelValue"])
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      (isMerge.value)
                                        ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                                            key: 0,
                                            title: "基本信息",
                                            name: "基本信息"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_103, [
                                                _hoisted_104,
                                                _createVNode(_component_el_select, {
                                                  style: {"flex":"1"},
                                                  modelValue: invoiceInfo.value.vatInfo.itemName,
                                                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((invoiceInfo.value.vatInfo.itemName) = $event)),
                                                  onChange: itemChange,
                                                  placeholder: "请选择项目名称"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemList.value, (item) => {
                                                      return (_openBlock(), _createBlock(_component_el_option, {
                                                        key: item.taxno,
                                                        label: item.name,
                                                        value: item.name
                                                      }, null, 8, ["label", "value"]))
                                                    }), 128))
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_105, [
                                                _hoisted_106,
                                                _createVNode(_component_el_select, {
                                                  onBlur: _cache[42] || (_cache[42] = (e)=>settingSelect(e,'specification')),
                                                  clearable: "",
                                                  filterable: "",
                                                  modelValue: invoiceInfo.value.vatInfo.specification,
                                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((invoiceInfo.value.vatInfo.specification) = $event)),
                                                  placeholder: "请输入或选择规格型号",
                                                  style: {"flex":"1"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specOptipon.value, (item) => {
                                                      return (_openBlock(), _createBlock(_component_el_option, {
                                                        key: item.id,
                                                        label: item.name,
                                                        value: item.name
                                                      }, null, 8, ["label", "value"]))
                                                    }), 128))
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_107, [
                                                _hoisted_108,
                                                _createVNode(_component_el_select, {
                                                  onBlur: _cache[44] || (_cache[44] = (e)=>settingSelect(e,'unit')),
                                                  clearable: "",
                                                  filterable: "",
                                                  style: {"flex":"1"},
                                                  modelValue: invoiceInfo.value.vatInfo.unit,
                                                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((invoiceInfo.value.vatInfo.unit) = $event)),
                                                  placeholder: "请输入或选择单位"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitOption.value, (item) => {
                                                      return (_openBlock(), _createBlock(_component_el_option, {
                                                        key: item.id,
                                                        label: item.name,
                                                        value: item.name
                                                      }, null, 8, ["label", "value"]))
                                                    }), 128))
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_109, [
                                                _hoisted_110,
                                                _createVNode(_component_el_input, {
                                                  onChange: _cache[46] || (_cache[46] = ()=>unitPriceOrquantityChange('quantity')),
                                                  style: {"flex":"1"},
                                                  modelValue: invoiceInfo.value.vatInfo.quantity,
                                                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((invoiceInfo.value.vatInfo.quantity) = $event))
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_111, [
                                                _hoisted_112,
                                                _createVNode(_component_el_input, {
                                                  onChange: _cache[48] || (_cache[48] = ()=>unitPriceOrquantityChange('unitPrice')),
                                                  style: {"flex":"1"},
                                                  modelValue: invoiceInfo.value.vatInfo.unitPrice,
                                                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((invoiceInfo.value.vatInfo.unitPrice) = $event))
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_113, [
                                                _hoisted_114,
                                                _createVNode(_component_el_input, {
                                                  style: {"flex":"1"},
                                                  disabled: !isAdvancePayment.value,
                                                  modelValue: invoiceInfo.value.vatInfo.totalAmount,
                                                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((invoiceInfo.value.vatInfo.totalAmount) = $event))
                                                }, null, 8, ["disabled", "modelValue"])
                                              ])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (isMerge.value)
                                        ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                                            key: 1,
                                            title: "销售方",
                                            name: "销售方"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_115, [
                                                _hoisted_116,
                                                _createVNode(_component_el_input, {
                                                  style: {"flex":"1"},
                                                  disabled: "",
                                                  modelValue: invoiceInfo.value.vatInfo.sellerName,
                                                  "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((invoiceInfo.value.vatInfo.sellerName) = $event))
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_117, [
                                                _hoisted_118,
                                                _createVNode(_component_el_input, {
                                                  style: {"flex":"1"},
                                                  disabled: "",
                                                  modelValue: invoiceInfo.value.vatInfo.companyCode,
                                                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((invoiceInfo.value.vatInfo.companyCode) = $event))
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_119, [
                                                _hoisted_120,
                                                _createVNode(_component_el_input, {
                                                  disabled: "",
                                                  style: {"flex":"1"},
                                                  modelValue: invoiceInfo.value.vatInfo.sellerAddress,
                                                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((invoiceInfo.value.vatInfo.sellerAddress) = $event))
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_121, [
                                                _hoisted_122,
                                                _createVNode(_component_el_input, {
                                                  disabled: "",
                                                  style: {"flex":"1"},
                                                  modelValue: invoiceInfo.value.vatInfo.sellerPhone,
                                                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((invoiceInfo.value.vatInfo.sellerPhone) = $event))
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_123, [
                                                _hoisted_124,
                                                _createVNode(_component_el_input, {
                                                  disabled: "",
                                                  style: {"flex":"1"},
                                                  modelValue: invoiceInfo.value.vatInfo.sellerBank,
                                                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((invoiceInfo.value.vatInfo.sellerBank) = $event))
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_125, [
                                                _hoisted_126,
                                                _createVNode(_component_el_input, {
                                                  disabled: "",
                                                  style: {"flex":"1"},
                                                  modelValue: invoiceInfo.value.vatInfo.sellerBankAccount,
                                                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((invoiceInfo.value.vatInfo.sellerBankAccount) = $event))
                                                }, null, 8, ["modelValue"])
                                              ])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "width"]),
    _createVNode(_component_el_dialog, {
      width: 960,
      onOpen: openBankList,
      modelValue: bankListVisiable.value,
      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((bankListVisiable).value = $event)),
      title: "收款银行"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[62] || (_cache[62] = ($event: any) => (selectBankHandle(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_135
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[63] || (_cache[63] = ($event: any) => (selectBankHandle(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_136
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (bankListVisiable.value)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              ref_key: "bankListRef",
              ref: bankListRef,
              onSelectionChange: bankListChange,
              border: "",
              data: invoiceInfo.value.invoiceInfo.bankList
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "55"
                }),
                _createVNode(_component_el_table_column, {
                  label: "银行名称",
                  prop: "bankName",
                  width: "120",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "国别",
                  prop: "country",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "币别",
                  prop: "currency",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  label: "账户信息",
                  prop: "accountInfo",
                  width: "400px"
                }, {
                  default: _withCtx(({row}) => [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_132, [
                      _createTextVNode(_toDisplayString(row.accountInfo), 1)
                    ])), [
                      [_directive_showTooltip, false]
                    ]),
                    _createVNode(_component_el_popover, {
                      placement: "right",
                      trigger: "hover",
                      width: 600
                    }, {
                      reference: _withCtx(() => [
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_133, [
                          _createTextVNode(_toDisplayString(row.accountInfo), 1)
                        ])), [
                          [_directive_showTooltip, true]
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          innerHTML: remarkHTML(row.accountInfo)
                        }, null, 8, _hoisted_134)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "备注",
                  prop: "note",
                  width: "150",
                  "show-overflow-tooltip": ""
                })
              ]),
              _: 1
            }, 8, ["data"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "500",
      modelValue: recreateReaonVisiable.value,
      "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((recreateReaonVisiable).value = $event)),
      title: "发票重开原因"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[66] || (_cache[66] = ($event: any) => (recreateReaonVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_137
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[67] || (_cache[67] = ($event: any) => (recreateMethods(resetInvoiceData.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_138
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: recreateReason.value,
          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((recreateReason).value = $event)),
          placeholder: "请输入发票重开原因"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      onClose: _cache[72] || (_cache[72] = ($event: any) => (nos.value='')),
      title: "导入",
      modelValue: isShowImport.value,
      "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((isShowImport).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[70] || (_cache[70] = ($event: any) => (isShowImport.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_139
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: submitImportLoading.value,
          onClick: _cache[71] || (_cache[71] = ($event: any) => (submitImport()))
        }, {
          default: _withCtx(() => [
            _hoisted_140
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          type: "textarea",
          placeholder: "请输入订单号，支持分隔符：, ; . /换行符，中文逗号或空格",
          rows: 4,
          modelValue: nos.value,
          "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((nos).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      "close-on-click-modal": false,
      onClose: closeChecOrderVisiable,
      modelValue: checkOrderVisiable.value,
      "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((checkOrderVisiable).value = $event)),
      width: "600"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[74] || (_cache[74] = ($event: any) => (checkOrderVisiable.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_149
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: updataOrderLoading.value,
          onClick: updataOrder
        }, {
          default: _withCtx(() => [
            _hoisted_150
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_141, [
          _createVNode(_component_el_icon, {
            size: "20",
            color: "#F56C6C"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CircleCloseFilled)
            ]),
            _: 1
          }),
          _hoisted_142,
          _hoisted_143
        ]),
        _createVNode(_component_el_scrollbar, { "max-height": "400px" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkRes.value, (item, index) => {
              return (_openBlock(), _createElementBlock("p", {
                class: "mb-15 pl-30",
                key: index
              }, [
                _createElementVNode("p", _hoisted_144, "COID：" + _toDisplayString(item.orderNo), 1),
                (item.diffAmount)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_145, "--订单金额不一致:当前为" + _toDisplayString(item.amount) + "|co2记录为" + _toDisplayString(item.co2Amount), 1))
                  : _createCommentVNode("", true),
                (item.diffCurrency)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_146, "--币种不一致:当前为" + _toDisplayString(item.currency) + "|co2记录为" + _toDisplayString(item.co2Currency), 1))
                  : _createCommentVNode("", true),
                (item.diffInvoiceCompany)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_147, "--发票主体不一致:当前为" + _toDisplayString(item.invoiceCompany) + "|co2记录为" + _toDisplayString(item.co2InvoiceCompany), 1))
                  : _createCommentVNode("", true),
                (item.diffStatus)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_148, "--订单状态不一致:当前为" + _toDisplayString(item.status) + "|co2记录为" + _toDisplayString(item.co2Status), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})